import { jsx, jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import Count from "./Count.js";
import { TAB_CLASSNAMES_BY_SIZE } from "./constants.js";
const Tab = ({ className, size = 's', selected, disabled, label, htmlProps, children, count, 'data-testidCount': dataTestIdCount, subtitle, withoutUnderline, styleSelectAround, showCountOnZero, ...tabprops })=>/*#__PURE__*/ jsxs("button", {
        type: "button",
        className: clsx('tw-button-base tw-relative tw-flex tw-items-center tw-justify-center tw-pb-1 tw-px-1.6', TAB_CLASSNAMES_BY_SIZE[size], {
            'dark:tw-text-neutral-dark-500 dark:hover:tw-text-neutral-light-100 tw-text-neutral-light-700': !selected,
            'dark:tw-text-secondary-dark-500 tw-text-primary-light-400': selected,
            'tw-cursor-not-allowed !tw-text-neutral-light-500 dark:!tw-text-neutral-dark-600': disabled,
            'tw-bg-primary-light-100 tw-rounded-1 dark:tw-bg-secondary-light-500 dark:!tw-text-neutral-light-800': styleSelectAround && selected
        }, className),
        disabled: disabled,
        ...htmlProps,
        ...tabprops,
        children: [
            label,
            void 0 !== count && (count > 0 || showCountOnZero) ? /*#__PURE__*/ jsx(Count, {
                count: count,
                "data-testid": dataTestIdCount,
                disabled: disabled,
                selected: selected,
                styleSelectAround: styleSelectAround
            }) : null,
            subtitle ? /*#__PURE__*/ jsx("span", {
                className: "tw-ml-1 tw-font-caption",
                children: subtitle
            }) : null,
            children,
            !withoutUnderline && /*#__PURE__*/ jsx("div", {
                className: clsx('tw-transition-opacity tw-duration-300 tw-absolute tw-bottom-0 tw-inset-x-0 tw-w-full tw-rounded-5 tw-h-[2px] dark:tw-bg-secondary-dark-500 tw-bg-primary-light-400', selected ? 'tw-opacity-1' : 'tw-opacity-0', disabled && '!tw-bg-neutral-light-500 dark:!tw-bg-neutral-dark-600')
            })
        ]
    });
const Tab_Tab = Tab;
export default Tab_Tab;
export { Tab };
